import Vue from 'vue';
import { Map, TileLayer, OsmSource, Feature, PointGeom, IconStyle, VectorLayer, StyleBox, CircleStyle, StrokeStyle, Overlay  } from 'vuelayers'

export default function MapsPlugin() {
    Vue.use(Map);
    Vue.use(TileLayer);
    Vue.use(OsmSource);
    Vue.use(Feature);
    Vue.use(PointGeom);
    Vue.use(IconStyle);
    Vue.use(VectorLayer);
    Vue.use(StyleBox);
    Vue.use(CircleStyle);
    Vue.use(StrokeStyle);
    Vue.use(Overlay);
}